import React from 'react';

import {ISocialLoginFactoryProps} from './ISocialLoginFactory';
import SocialLogin from './SocialLogin';

import styles from './SocialLogin.module.scss';

const SocialLoginFactory = function (props: ISocialLoginFactoryProps) {
	const {type} = props;

	switch (type) {
		case 'line':
			return (
				<SocialLogin classNames={styles['auth__login-form__social']}>
					<SocialLogin.Line />
				</SocialLogin>
			);
		default:
			return <></>;
	}
};

export default SocialLoginFactory;